module.exports = __webpack_public_path__ + "static/img/weixin-icon.e17c5cdd.png";